import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description OnlineLoans icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { OnlineLoans } from '@sravni/design-system-icons'
 *
 * <OnlineLoans />
 * ```
 */
var OnlineLoans = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "OnlineLoans", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.23 3.104a4.12 4.12 0 0 1 0 5.866 4.217 4.217 0 0 1-5.922 0 4.12 4.12 0 0 1 0-5.866 4.217 4.217 0 0 1 5.922 0ZM6.646 15.716H8.89", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12.77 10.185v6.025a1.984 1.984 0 0 1-1.995 1.975H4.792a1.984 1.984 0 0 1-1.994-1.975V4.358c0-1.091.892-1.975 1.994-1.975h5.382", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.462 8.407a.337.337 0 0 1-.336-.337V4.666c0-.552.455-1 1.008-1 .653 0 1.137.118 1.451.352.32.235.48.576.48 1.023 0 .3-.078.56-.233.777-.154.212-.384.376-.688.491-.3.115-.671.173-1.115.173h-.23V8.07c0 .186-.15.337-.337.337Zm-.772-.903a.216.216 0 1 1 0-.432h2.128a.216.216 0 1 1 0 .432H10.69Zm.037-1.022a.252.252 0 0 1 0-.505h1.062v.505h-1.062Zm1.205-.505c.193 0 .56-.029.77-.086a.96.96 0 0 0 .494-.286c.115-.133.172-.314.172-.544 0-.301-.104-.525-.314-.67-.21-.147-.536-.22-.98-.22h-.075a.2.2 0 0 0-.2.2v1.455c0 .084.05.151.133.151Z", fill: "currentColor", stroke: "currentColor", strokeWidth: ".3", strokeLinejoin: "round" }))); });

export { OnlineLoans };
//# sourceMappingURL=OnlineLoans.js.map
